import axios from 'axios';
import { LIVE_LINK } from '../helpers/url_helper';

export const fetchTrackingStatuses = async (trackingNumbers, type) => {
  if (!trackingNumbers || trackingNumbers.length === 0) {
    console.error('🚨 Error: No tracking numbers provided.');
    return {};
  }
  try {
    const formattedTrackingNumbers = trackingNumbers.map((trackingNumber) => ({
      number: String(trackingNumber).trim() // ✅ Ensures all numbers are strings
    }));
    const { data } = await axios.post(`${LIVE_LINK}/17track/track`, [formattedTrackingNumbers, type]);

    console.log('✅ Tracking Data Received'); // Debug response
    return data;
  } catch (error) {
    console.error('🚨 Error fetching tracking statuses:', error.response?.data || error.message);
    return {};
  }
};
